import { InjectionToken } from '@angular/core';

import { MonitoringModule } from './monitoring.interface';

export const MONITORING: InjectionToken<MonitoringModule> = new InjectionToken('monitoring');
